export const AgencyFavoriteIds = [
  'ckrmnakdk7khr0e76hil16hvz',
  'ckrmn9auo7i7h0c655l8qeem7',
  'ckrmnjz407r4x0c75qveb35t0',
  'ckrmne7js7pcr0c75sq2klck7',
  'ckrmngf0w7qiq0e76swfujgas',
  'ckrp7eils1svy0b69nhv5knh8',
  'ckrmn9u547kqb0b20uwyx65x5',
  'ckrmndhbc7nkc0c65vxuzlv1g',
  'ckrmnb4fs7l2e0c75i4ixmcmx',
  'ckrmndl687ogi0c75b26pstms',
  'ckrmndrcg7oop0c75sbqytav1',
  'ckrmnae7c7lfh0b203pzq8blx',
  'ckrmndufk7oy70e76rho8x2sc',
  'ckrmnay9k7ktr0c75cf5i7y12',
  'ckrmne1dk7qj00b20ym77yw1c',
  'ckrmnbam07ms40b20j5ejf96t',
  'ckrmnef9k7plo0c75v8fi9gjj',
  'ckrmnjz407r4x0c75qveb35t0',
  'ckrmnlwk07szh0b20oa67n9vk',
  'ckrmngf0w7qiq0e76swfujgas',
];
